import React from 'react';
import { Form as FormikForm } from 'formik';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { Box } from 'app/shared/components/atoms';
import { ActionButton, Textfield } from 'app/shared/components/molecules';

interface FormProps {
  formikProps: any;
  ctaText?: string;
  fullWidthCta?: boolean;
}
export const FormWithoutCitySelector: React.FC<
  React.PropsWithChildren<FormProps>
> = ({ formikProps, ctaText, fullWidthCta }) => {
  const intl = useIntl();
  const { errors, isSubmitting, values, touched, setFieldValue } = formikProps;
  const { colors } = useCurrentTheme();

  return (
    <FormikForm>
      <Box
        w="100%"
        gap={8}
        flexDirection="column"
        data-qaid="newsletter-form-without-city"
      >
        <Textfield
          hasError={touched.email && !!errors.email}
          helperText={touched.email ? errors.email : undefined}
          label={intl.formatMessage({ id: 'form.fields.email' })}
          onChange={(event: any) => setFieldValue('email', event.target.value)}
          value={values.email}
          // @ts-ignore
          type="email"
          autoCapitalize="off"
          data-qaid="newsletter-form-without-city-email"
          labelColor={colors.primary.white.base}
        />
        <ActionButton
          variant="primary"
          isLoading={isSubmitting}
          type="submit"
          data-qaid="newsletter-form-without-city-submit"
          fullWidth={fullWidthCta}
        >
          {ctaText || intl.formatMessage({ id: 'newsletter.unlockNow' })}
        </ActionButton>
      </Box>
    </FormikForm>
  );
};
